// TODO: Genericify
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { I18n } from "@lingui/react";
import { connect } from "react-redux";
import { Trans } from "@lingui/macro";
import { updateSortFunc } from "../../../redux/modules/_BETA/actionsUI";

import Menu from "../../../components/Menu";

import { actionColumns } from "../../../utils/columns";
import { $Select } from "./ActionsMenus.styles";

@connect(
  (state) => ({
    sortFilter: state.betaActionsUI.sortFilter,
  }),
  (dispatch) => ({
    onSortChange: (sortFuncKey) => dispatch(updateSortFunc(sortFuncKey)),
  })
)
class SortSelect extends PureComponent {
  static propTypes = {
    sortFilter: PropTypes.string.isRequired,
    onSortChange: PropTypes.func.isRequired,
  };

  handleSortChange = (sortKey, cb) => () => {
    this.props.onSortChange(sortKey);
    cb();
  };

  render() {
    return (
      <div>
        <I18n>
          {({ i18n }) => (
            <Menu>
              {({ isOpen, menuRef, toggle, close }) => (
                <$Select ref={menuRef}>
                  <$Select.label onClick={toggle}>
                    <Trans id="sort_select.label">Sort</Trans>
                    <$Select.triangle tiny />
                  </$Select.label>
                  <$Select.list isOpen={isOpen}>
                    <$Select.title>
                      <Trans id="sort_select.title">SORT BY</Trans>
                    </$Select.title>
                    {Object.entries(actionColumns).map(([key, column]) => (
                      <$Select.option
                        isActive={this.props.sortFilter === key}
                        key={key}
                        onClick={this.handleSortChange(key, close)}
                      >
                        {column.label(i18n)}
                      </$Select.option>
                    ))}
                  </$Select.list>
                </$Select>
              )}
            </Menu>
          )}
        </I18n>
      </div>
    );
  }
}

export default SortSelect;
